import { Dialog, DialogActions } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import WholeBodyBackBurnSvg from 'FRONTEND/components/BodySelectionField/whole-body-back-burn.svg';
import WholeBodyBackSvg from 'FRONTEND/components/BodySelectionField/whole-body-back.svg';
import WholeBodySvg from 'FRONTEND/components/BodySelectionField/whole-body.svg';
import i18n from 'FRONTEND/utils/i18n';

const UNSELECTED_COLOR = '#fffbe7';

const photoToSvg = {
  'whole-body.svg': <WholeBodySvg />,
  'whole-body-back.svg': <WholeBodyBackSvg />,
  'whole-body-back-burn.svg': <WholeBodyBackBurnSvg />,
};

const BodySelectionField = ({
  id,
  photo,
  height,
  width,
  verticalOffset,
  draft,
  levels,
  values,
}) => {
  const [clickEventsAssociated, setClickEventsAssociated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAreaInModal, setSelectedAreaInModal] = useState(null);
  const [selectedValues, setSelectedValues] = useState(values || []);
  const svgDivRef = useRef(null);

  useEffect(() => {
    if (!svgDivRef.current) {
      return;
    }

    // Add DOM-level click event for SVG groups and paths.
    const pathEls = Array.from(svgDivRef.current.querySelectorAll('svg > path'));
    const groupEls = Array.from(svgDivRef.current.getElementsByTagName('g'));

    if (!clickEventsAssociated) {
      setClickEventsAssociated(true);

      pathEls.forEach((path) => {
        path.addEventListener('click', (e) => {
          const el = e.target;
          handleSvgAreaClick(el, false);
        });
      });
      groupEls.forEach((group) => {
        group.addEventListener('click', (e) => {
          const el = e.target.nodeName === 'path' ? e.target.parentNode : e.target;
          handleSvgAreaClick(el, true);
        });
      });
    }

    pathEls.forEach((pathEl) => {
      const selectedArea = selectedValues?.find((val) => val.id === pathEl.id);
      if (selectedArea) {
        const level = levels.find((level) => level.valueId === selectedArea.value);
        pathEl.style.fill = level.color;
      } else {
        pathEl.style.fill = UNSELECTED_COLOR;
      }
    });
    groupEls.forEach((groupEl) => {
      const paths = Array.from(groupEl.getElementsByTagName('path'));
      const selectedArea = selectedValues?.find((val) => val.id === groupEl.id);
      if (selectedArea) {
        paths.forEach((path) => {
          const level = levels.find((level) => level.valueId === selectedArea.value);
          path.style.fill = level.color;
        });
      } else {
        paths.forEach((path) => {
          path.style.fill = UNSELECTED_COLOR;
        });
      }
    });

    document.getElementById(id).value = selectedValues.length ? JSON.stringify(selectedValues) : null;
  });

  // To remove, pass a level of null.
  const commitSelectionChangeOnArea = (selectedId, level) => {
    const index = selectedValues.findIndex((val) => val.id === selectedId);
    const newSelectedValues = selectedValues;
    if (index !== -1) {
      newSelectedValues.splice(index, 1);
    }

    if (level) {
      newSelectedValues.push({ id: selectedId, value: level.valueId });
    } else {
      setSelectedAreaInModal(null);
    }
    setSelectedValues(newSelectedValues);
  };

  const handleSvgAreaClick = (el) => {
    if (values && !draft) {
      return;
    }
    setSelectedAreaInModal(el.id);
    setShowModal(true);
  };

  const handleLevelSelectionClick = (level) => {
    commitSelectionChangeOnArea(selectedAreaInModal, level);
    setShowModal(false);
  };

  const renderInlineLegend = () => (
    <div className='bodySelectionField__inlineLegendContainer'>
      {levels.map((level, index) => {
        level.index = index;
        return (
          <div className='bodySelectionField__legend' key={index}>
            <div className='bodySelectionFieldLegend__color' style={{ background: level.color, width: '80px' }} />
            <div>{level.displayName}</div>
          </div>
        );
      })}
    </div>
  );

  const renderModalLevelSelection = () => (
    <div className='bodySelectionField__dialogContainer'>
      {selectedValues?.find((val) => val.id === selectedAreaInModal) &&
        <div
          className='bodySelectionField__legend clickable'
          onClick={() => handleLevelSelectionClick(null)}
        >
          <div
            className='bodySelectionFieldLegend__color'
            style={{ border: '1px solid #ffc800', background: UNSELECTED_COLOR, width: '80px' }}
          />
          <div>{i18n._('Erase')}</div>
        </div>}
      {
        levels.map((level, index) => {
          level.index = index;
          return (
            <div
              className='bodySelectionField__legend clickable'
              onClick={() => handleLevelSelectionClick(level)} key={index}
            >
              <div className='bodySelectionFieldLegend__color' style={{ background: level.color, width: '80px' }} />
              <div>{level.displayName}</div>
            </div>
          );
        })
      }
    </div>
  );

  const renderComplexSvg = () => (
    <div className='bodySelectionField__svgContainer' style={{ height, width }} ref={svgDivRef}>
      {photoToSvg[photo]}
    </div>
  );

  return (
    <div className='bodySelectionField'>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        {showModal && (
          <DialogActions>
            {renderModalLevelSelection()}
          </DialogActions>
        )}
      </Dialog>
      <div
        style={{
          paddingTop: `${verticalOffset}px`,
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        {renderComplexSvg()}
      </div>
      {renderInlineLegend()}
      <div className='bodySelectionField-input'>
        <input id={id} name={id} type='text' />
      </div>
    </div>
  );
};

export default BodySelectionField;
